import { render, staticRenderFns } from "./DarkModel.vue?vue&type=template&id=b23b52e0&scoped=true"
import script from "./DarkModel.vue?vue&type=script&lang=js"
export * from "./DarkModel.vue?vue&type=script&lang=js"
import style0 from "./DarkModel.vue?vue&type=style&index=0&id=b23b52e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23b52e0",
  null
  
)

export default component.exports